import { Component, OnInit, inject } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Textarea} from './textarea';

@Component({
    templateUrl: './textarea.component.html',
    styleUrls: ['./textarea.component.scss'],
    standalone: false
})
export class TextareaComponent implements OnInit {
  textarea = inject<Textarea>(MAT_DIALOG_DATA);
  dialogRef = inject<MatDialogRef<TextareaComponent>>(MatDialogRef);

  inputValue: string;

  ngOnInit(): void {
    this.inputValue = this.textarea.text || '';
  }

  onAddInput(): void {
    this.dialogRef.close(this.getTrimmedInput());
  }

  isEmpty(): boolean {
    return !this.getTrimmedInput();
  }

  private getTrimmedInput(): string {
    return this.inputValue.trim();
  }
}
